import { NotificationAlertType } from '../enums/notification-alert-type.enum';
import { NotificationStatus } from '../enums/notification-status.enum';
import { TenantFilter } from '../prothesis-base-api-filters/tenant-filter';

export class NotificationFilter extends TenantFilter {
  declare public discriminator: string | null;
  declare public notificationAlertType: NotificationAlertType | null;
  declare public notificationStatus: NotificationStatus | null;
}
